<div mat-dialog-content [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}">
	<h2 *ngIf="popupTitle">{{popupTitle}}</h2>
    <p class="alert" [ngClass]="alignClass" tabindex="0" [innerHTML]="popupMessage"></p>
</div>
<div mat-dialog-actions class="button">
	<button mat-button matDialogClose="confirm" (click)="onOk()">{{popupOk}}</button>
	<button *ngIf="popupCancel" matDialogClose="cancel" mat-button (click)="onCancel()">{{popupCancel}}</button>
</div>